
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

export const ScheduleHeader = () => {
  return (
    <div className="text-center mb-16">
      <Link to="/tickets">
        <Button 
          className="mb-12 text-lg px-8 py-6 bg-gradient-to-r from-[#F97316] to-[#ea384c] hover:opacity-90 text-white font-semibold shadow-lg"
        >
          Register Now
        </Button>
      </Link>

      <div className="mb-8">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          Full Agenda 2026
        </h2>
        <p className="max-w-3xl mx-auto text-lg text-blue-200">
          Explore our comprehensive two-day schedule
        </p>
      </div>
    </div>
  );
};
